import request from '@/api/http'

export function listStrategies() {
  return request({ url: '/report/strategy/strategies', method: 'get' })
}

export function getStrategyOverview(params) {
  return request({ url: '/report/strategy/overview', method: 'get', params: params })
}

export function getStrategySummary(params) {
  return request({ url: '/report/strategy/summary', method: 'get', params: params })
}

export function getByUser(params) {
  return request({ url: '/report/strategy/byUser', method: 'get', params: params })
}

export function getByAccount(params) {
  return request({ url: '/report/strategy/byAccount', method: 'get', params: params })
}

export function getByBook(params) {
  return request({ url: '/report/strategy/byBook', method: 'get', params: params })
}

export function getCampaigns(params) {
  return request({ url: '/report/strategy/campaigns', method: 'get', params: params })
}

export function getAds(params) {
  return request({ url: '/report/strategy/ads', method: 'get', params: params })
}

export function getMaterials(params) {
  return request({ url: '/report/strategy/materials', method: 'get', params: params })
}

/** 按当前表格行上下文（策略+账户/系列/组/广告）查关联素材及消耗（分页）；cancelToken 不入 query */
export function getMaterialsForRow(params) {
  const p = params || {}
  const { cancelToken, ...query } = p
  return request({
    url: '/report/strategy/materials/for-row',
    method: 'get',
    params: query,
    timeout: 60000,
    cancelToken: cancelToken
  })
}
